import { Route } from "react-router-dom";

import {
  ADD_CLIENT_INCOME,
  ADD_CLIENT_PAYMENT,
  EDIT_CLIENT_INCOME,
  EDIT_CLIENT_PAYMENT,
  VIEW_CLIENT,
  VIEW_CLIENT_STATEMENT,
} from "src/constants";
import { CLIENT_ROUTES } from "src/pages/client/constants";
import { ProtectedRoute } from "src/utils/ProtectedRoute";

import { AddEditIncome } from "./AddEditIncome.page";
import { AddEditReceivables } from "./AddEditReceivables.page";
import { ClientInvoice } from "./ClientInvoice.page";
import { ClientReceipt } from "./ClientReceipt.page";
import { Clients } from "./Clients.page";
import { SingleClient } from "./SingleClient.page";

/** Route tree for the client module, mounted under `/clients`, `/client`, `/add-income`, `/edit-income` and `/receivables`. */
export const clientRoutes = (
  <>
    <Route path={CLIENT_ROUTES.root} element={<ProtectedRoute permissions={VIEW_CLIENT} component={Clients} />} />
    <Route
      path={CLIENT_ROUTES.details}
      element={<ProtectedRoute permissions={VIEW_CLIENT} component={SingleClient} />}
    />
    <Route
      path={CLIENT_ROUTES.invoice}
      element={<ProtectedRoute permissions={VIEW_CLIENT_STATEMENT} component={ClientInvoice} />}
    />
    <Route
      path={CLIENT_ROUTES.receipt}
      element={<ProtectedRoute permissions={VIEW_CLIENT_STATEMENT} component={ClientReceipt} />}
    />
    <Route
      path={CLIENT_ROUTES.addIncome}
      element={<ProtectedRoute permissions={ADD_CLIENT_INCOME} component={AddEditIncome} />}
    />
    <Route
      path={CLIENT_ROUTES.editIncome}
      element={<ProtectedRoute permissions={EDIT_CLIENT_INCOME} component={AddEditIncome} />}
    />
    <Route
      path={CLIENT_ROUTES.addReceivable}
      element={<ProtectedRoute permissions={ADD_CLIENT_PAYMENT} component={AddEditReceivables} />}
    />
    <Route
      path={CLIENT_ROUTES.editReceivable}
      element={<ProtectedRoute permissions={EDIT_CLIENT_PAYMENT} component={AddEditReceivables} />}
    />
  </>
);
